module.exports = __webpack_public_path__ + "img/12.693f67f7.jpg";